export const groupTypes = {
  M365Group: 'M365Group',
  SecurityGroup: 'SecurityGroup',
  DistributionGroup: 'DistributionGroup',
  SharedMailbox: 'SharedMailbox',
  SecurityMailEnabledGroup: 'SecurityMailEnabledGroup',
}
